import React from 'react'
import Swal from 'sweetalert2'
import useForm from '../../hooks/useForm'

const CreateServiceModal = ({ isOpen, onClose, onSuccess }) => {
    const API_URL = process.env.REACT_APP_API_URL;

    const validate = async (values) => {
        const errors = {};
        if (!values.code) errors.code = "Please enter code";
        if (!values.service) errors.service = "Please enter service";
        return errors;
    };    

    const { values, errors, isSubmitting, handleChange, handleSubmit, resetForm } = useForm(
        { 
            code: '',
            service: ''
        },
        validate
    );
        
    const onSubmit = async (values) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/services`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(values)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to create employee');
            }

            const data = await response.json();
            resetForm();

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }            
        
            onClose();

            Swal.fire({
                title: 'Success!',
                text: data.message,
                icon: 'success',
                showConfirmButton: false,
                timer: 5000
            });
        } catch (error) {
            console.error('Error creating services:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message,
                icon: 'error',
                showConfirmButton: false,
                timer: 5000
            });
        }
    };

    return (
        <>
            <div id="static-modal" className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${isOpen ? 'flex' : 'hidden'}`} data-modal-backdrop="static" tabIndex="-1" aria-hidden="true">
                <div className="relative p-4 w-full max-w-2xl max-h-full">
                    <div className="relative bg-white rounded-lg shadow">
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
                            <h3 className="text-xl font-semibold text-gray-900">
                                Create Service Modal
                            </h3>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                onClick={onClose}
                            >
                                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="p-4 md:p-5 space-y-4">
                            <form onSubmit={(e) => handleSubmit(e, onSubmit)}>
                                <div className='flex flex-col  w-full'>
                                    <div className="mb-4 w-full">
                                        <label htmlFor="code" className="block text-sm font-medium text-gray-700">Code</label>
                                        <input 
                                            type="text" 
                                            id="code" 
                                            name="code" 
                                            value={values.code} 
                                            onChange={handleChange} 
                                            className="form-input mt-1 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800" required
                                        />
                                        {errors.code && (
                                            <p className="text-red-600">{errors.code}</p>
                                        )}
                                    </div>
                                    <div className="mb-4 w-full">
                                        <label htmlFor="service" className="block text-sm font-medium text-gray-700">Service</label>
                                        <input 
                                            type="text" 
                                            id="service" 
                                            value={values.service} 
                                            name='service'
                                            onChange={handleChange} 
                                            className="form-input mt-1 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800" required 
                                        />
                                        {errors.service && (
                                            <p className="text-red-600">{errors.service}</p>
                                        )}
                                    </div>    
                                </div>
                            
                                <div className="flex items-center pt-3 border-t border-gray-200 rounded-b">
                                    <button 
                                        type="submit" 
                                        className="text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Saving' : 'Save'}
                                    </button>
                                    <button type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-red-700 focus:z-10 focus:ring-4 focus:ring-gray-100" onClick={onClose}>Close</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateServiceModal;
